import { router } from '@/core/router';
import { isOpenChatbotHref, openKindly } from '@/core/navigation/chatbot.utils';

// Fallback for matches for IE11
if (!Element.prototype.matches) {
    Element.prototype.matches = (Element.prototype as any).msMatchesSelector;
}

const delegateHtmlLinksDirective = {
    beforeMount(el: HTMLElement) {
        el.addEventListener('click', event => {
            const { target }: any = event;

            if (isOpenChatbotHref(target?.href)) {
                event.preventDefault();
                openKindly();
                return;
            }
            // only links that do not reference external resources
            if (target && target.matches('a:not([href*=\'://\'])') && target.href) {
                const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event;

                if (metaKey || altKey || ctrlKey || shiftKey) {
                    return;
                }

                if (defaultPrevented) {
                    return;
                }

                if (button !== undefined && button !== 0) {
                    return;
                }

                if (target && target.getAttribute) {
                    const linkTarget = target.getAttribute('target');
                    if (/\b_blank\b/i.test(linkTarget)) {
                        return;
                    }
                }

                const url = new URL(target.href);
                const to = url.pathname + url.search;
                if (window.location.pathname !== to && event.preventDefault) {
                    event.preventDefault();
                    router.push(to);
                }
            }
        });
    },
};

export default delegateHtmlLinksDirective;
